import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionInterface } from 'probonio-shared-ui/registry/extension-definition';
import { ReactNode } from 'react';
import { BenefitMetadataExtensionInterface } from './benefit-metadata.extension.interface';

export interface BenefitLinkProps {
  managerSpecific?: string;
  managerSpecificLabel?: string;
  appSpecific?: string;
  appSpecificLabel?: string;
  hideGeneral?: boolean;
}

export interface BenefitSpecialLinkProps {
  title: string;
  link: string;
}

export interface BenefitInfoTextProps {
  benefit?: BenefitDTOBenefitEnum;
  hasNonCashBenefits?: boolean;
}

export abstract class BenefitInfoTextExtensionInterface extends ExtensionInterface {
  abstract getBenefitLinks(): BenefitLinkProps | undefined;

  abstract getBenefitMoreLinks(): BenefitSpecialLinkProps | undefined;

  abstract getHelpCenterLink(): string | undefined;

  abstract renderAdditionalContent(props: BenefitInfoTextProps): ReactNode;
}

const benefitInfoTextCache = new Map<BenefitDTOBenefitEnum, BenefitInfoTextExtensionInterface>();

/**
 * Retrieves the info text extension for a specific benefit type.
 * Uses caching to avoid redundant EXTENSIONS lookups.
 *
 * @param benefit - The benefit enum value (e.g., BenefitDTOBenefitEnum.Lunch)
 * @returns The matched benefit info text extension, or undefined if none exist
 */
export function getBenefitInfoText(benefit: BenefitDTOBenefitEnum): BenefitInfoTextExtensionInterface | undefined {
  if (benefitInfoTextCache.has(benefit)) {
    return benefitInfoTextCache.get(benefit);
  }

  const extensionKeyForBenefit = EXTENSIONS.getKeyedProviders(BenefitMetadataExtensionInterface).find(
    ({ provider }) => provider.benefitId === benefit,
  )?.key;
  const benefitInfoTextProvider = EXTENSIONS.getProviderByKey(extensionKeyForBenefit, BenefitInfoTextExtensionInterface);

  if (!benefitInfoTextProvider) {
    return undefined;
  }

  benefitInfoTextCache.set(benefit, benefitInfoTextProvider);

  return benefitInfoTextProvider;
}
